export default __webpack_public_path__ + "static/media/intermediate_avatar.c672a42d.jpg";